import Link from "next/link";

import styles from "./sign-in-link.module.css";

/**
 * The standard signed-out "Log In" link. Shared by `<AuthMenu>` (server) and
 * `<AuthIsland>` (client), so both storefront trees paint the identical link.
 *
 * prefetch={false}: this link sits in the header of every public page, and
 * Next eagerly prefetches in-viewport links. The sign-in route used to pull
 * ~103 KB of auth-vendor client JS, so prefetching loaded that whole bundle on
 * every tour/home view as dead weight. The bundle is gone, but the reasoning
 * is not: log-in is rarely the next click from a tour page, so fetching it on
 * click is still the right trade.
 *
 * No public sign-up — customer accounts are created at checkout and surfaced
 * via the post-booking claim email.
 */
export function SignInLink({
  label,
  href,
}: {
  label: string;
  href: string;
}): React.ReactElement {
  return (
    <div className={styles.menu}>
      <Link href={href} prefetch={false} className={styles.logIn}>
        {label}
      </Link>
    </div>
  );
}
